import { render, staticRenderFns } from "./ProductStatitics.vue?vue&type=template&id=a3e9fd94&scoped=true"
import script from "./ProductStatitics.vue?vue&type=script&lang=js"
export * from "./ProductStatitics.vue?vue&type=script&lang=js"
import style0 from "./ProductStatitics.vue?vue&type=style&index=0&id=a3e9fd94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e9fd94",
  null
  
)

export default component.exports